<script setup>
import {exchangeRate,goUp} from '@/utils/index'
import { useUserStore } from '@/stores/userStore';
import { useCartStore } from '@/stores/cartStore'
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n'
const { t, locale } = useI18n();
const cartStore = useCartStore()
const userStore = useUserStore()
const router = useRouter()
const loginModel=ref(false);
const goCart = () => {
    if (userStore.userInfo.token) {
        router.push('/member/cartlist')
    } else {
        //加载登录
        loginModel.value=true
    }

}
const handleClose=()=>{
    loginModel.value=false
    
}
/**
 * 删除
 * @param userId 
 * @param id 
 */
 const onDel = (userId, id, skuid) => {
    ElMessageBox.confirm(
        t('number111'),
        t('cart10'),
        {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
            //   center: true,
        }
    )
        .then(() => {
            let data = []
                data = [{ product_id: id, sku_id: skuid}]
                cartStore.delCart(data)
           
        })
        .catch((e) => {
            console.log('err',e)

            ElMessage({
                type: 'info',
                message: t('number113'),
            })
        })
}
const isMobile = ref(false);//false代表pc
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    console.log('Is mobile device:', isMobile.value);
})
onMounted(() => {
    if(userStore.userInfo.token){
        if(isMobile.value ==false){
            cartStore.updateNewList()
        }
        
    }
});

</script>

<template>
    <div class="cart">
        <a class="curr" href="javascript:;">
            <svg-icon icon-class="icon-cart" style="width: 24px; height: 28px;"/><em>{{ cartStore.menuAllCount }}</em>
        </a>
        <div class="layer">
            <div class="list">
                <div v-for="(list, i) in cartStore.cartList" :key="i">

                    <div class="username">
                        {{ list.shop_user }}
                    </div>

                    <div class="item" v-for="item in list.list" :key="item.id">
                        <RouterLink to="">
                            <img :src="item.cover_url" alt="" />
                            <div class="center">
                                <p class="name ellipsis">
                                    {{ item.name }}
                                </p>
                                <p class="attr ellipsis">{{ item.sku_name  }}</p>
                            </div>
                            <div class="right">
                                <p class="price"><span v-if="userStore.exchangeRate.symbol=='¥'">¥{{item.price}}</span>{{ exchangeRate(item.price,userStore.exchangeRate.symbol,userStore.exchangeRate.rate) }}</p>
                                
                                <p class="count">*{{ item.quantity }}</p>
                            </div>
                        </RouterLink>
                        <i class="iconfont icon-close-new" @click="onDel(list.shop_user_id, item.id,item.sku_id)"></i>
                    </div>


                </div>

            </div>
            <div class="foot">
                <div class="total">
                    <p>{{ $t("home13") }} {{ cartStore.menuAllCount }} {{ $t("home14") }}</p>
                    <p>
                        <span class="footlable">{{ $t('setup457') }}:</span>
                        <span v-if="userStore.exchangeRate.symbol=='¥'">¥ {{ goUp(cartStore.menuAllPrice)}}</span>
                        <span v-else>{{userStore.exchangeRate.symbol}}{{goUp(cartStore.menuAllPrice)}}</span>
                    </p>
                </div>
                <div class="goCart HorizontalCenter" @click="goCart()">{{ $t("home15") }}</div>
                <!-- <el-button size="large" type="primary" ></el-button> -->
            </div>
        </div>
    </div>
    <el-dialog
    v-model="loginModel"
    width="350"
    :before-close="handleClose"
  >
  <loginView :loginType="1" @close="handleClose"></loginView>
  </el-dialog>
   
</template>

<style scoped lang="scss">
.cart {
    width: 50px;
    position: relative;
    z-index: 600;

    .curr {
        height: 32px;
        line-height: 32px;
        text-align: center;
        position: relative;
        display: block;

        .icon-cart {
            font-size: 22px;
        }

        em {
            font-style: normal;
            position: absolute;
            right: 0;
            top: 0;
            padding: 1px 6px;
            line-height: 1;
            background: $helpColor;
            color: #fff;
            font-size: 12px;
            border-radius: 10px;
            font-family: Arial;
        }
    }

    &:hover {
        .layer {
            opacity: 1;
            transform: none;
        }
    }

    .layer {
        opacity: 0;
        transition: all 0.4s 0.2s;
        transform: translateY(-200px) scale(1, 0);
        width: 400px;
        height: 400px;
        position: absolute;
        top: 50px;
        right: 0;
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        background: #fff;
        border-radius: 4px;
        padding-top: 10px;

        &::before {
            content: "";
            position: absolute;
            right: 14px;
            top: -10px;
            width: 20px;
            height: 20px;
            background: #fff;
            transform: scale(0.6, 1) rotate(45deg);
            box-shadow: -3px -3px 5px rgba(0, 0, 0, 0.1);
        }

        .foot {
            position: absolute;
            left: 0;
            bottom: 0;
            height: 70px;
            width: 100%;
            padding: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: #F3F6F8;
            border-radius: 0px 0px 8px 8px;

            .total {
                padding-left: 10px;
                font-family: MicrosoftYaHei;
                font-size: 14px;
                color: #666666;
                line-height: 19px;
                text-align: left;
                font-style: normal;

                p {
                    .footlable{
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #0F0F0F;
                        line-height: 19px;
                        text-align: left;
                        font-style: normal;
                    }
                    &:last-child {
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #FC3938;
                        line-height: 18px;
                        text-align: left;
                        font-style: normal;
                    }
                }
            }
            .goCart{
                padding:0 20px;
                height: 40px;
                background: #FC3938;
                border-radius: 23px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 21px;
                // text-align: left;
                font-style: normal;
            }
        }
    }

    .list {
        height: 310px;
        overflow: auto;
        padding: 10px 20px;
        .username{
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #1F1F1F;
            line-height: 14px;
            text-align: left;
            font-style: normal;
        }

        &::-webkit-scrollbar {
            width: 10px;
            height: 10px;
        }

        &::-webkit-scrollbar-track {
            background: #f8f8f8;
            border-radius: 2px;
        }

        &::-webkit-scrollbar-thumb {
            background: #eee;
            border-radius: 10px;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: #ccc;
        }

        .item {
            border-bottom: 1px solid #f5f5f5;
            padding: 10px 0;
            position: relative;

            i {
                position: absolute;
                bottom: 38px;
                right: 0;
                opacity: 0;
                color: #666;
                transition: all 0.5s;
            }

            &:hover {
                i {
                    opacity: 1;
                    cursor: pointer;
                }
            }

            a {
                display: flex;
                align-items: center;

                img {
                    height: 78px;
                    width: 78px;
                    border-radius: 8px;
                }

                .center {
                    padding: 0 10px;
                    width: 200px;

                    .name {
                        font-family: MicrosoftYaHei, MicrosoftYaHei;
                        font-weight: bold;
                        font-size: 16px;
                        color: #11192D;
                        line-height: 25px;
                        text-align: left;
                        font-style: normal;
                    }

                    .attr {
                        color: #999;
                        padding-top: 5px;
                    }
                }

                .right {
                    width: 100px;
                    padding-right: 20px;
                    text-align: end;

                    .price {
                        
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #FC3938;
                        line-height: 19px;
                        font-style: normal;
                    }

                    .count {
                        margin-top: 5px;
                        font-family: MicrosoftYaHei;
                        font-size: 14px;
                        color: #666666;
                        line-height: 19px;
                        font-style: normal;
                    }
                }
            }
        }
    }
}
</style>